
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheBanner extends Vue {
  @Prop() data!: any;
}
